declare var LogonAspxRadAjaxLoadingPanel1ClientID: string; //see Logon.Aspx markup

function readyFunctionLogonAspx() {
   console.log('is ready')
   // wok - 20.11.17 - added ClientJS for client fingerprinting
   var client = new ClientJS();
   var fingerprint = client.getFingerprint();
   $('#cFieldFingerprint').val(fingerprint.toString());
   $('#cFieldPassword').tooltip
   $('#form1').submit(function (e) {
      if (!$('#cFieldUserName').val() || !$('#cFieldPassword').val()) {
         console.log('Error')
         $('#cFieldUserName').css('borderColor', 'red');
         $('#cFieldPassword').css('borderColor', 'red');
         $('#cMessage').html('Username and/or Password can not be empty!');
         return false;
         //e.preventDefault();
      }
   });
}
// OG - 11.09.13 on blur event
$('input').blur(function () {
   if (this.id == "pUserName") {
      if (!emptyValidate($(this), $('#error4'))) return;
      if (!containsChar($(this), $('#error4'), "\\") && !containsChar($(this), $('#error4'), "@")) {
         $('#error4').text($('#domainError').text());
      }
   }
   if (this.id == "oldPassword")
      emptyValidate($(this), $('#error1'));

   if (this.id == "password")
      emptyValidate($(this), $('#error2'));

   if (this.id == "passwordCofirm")
      emptyValidate($(this), $('#error3'));

});
//get out of frame
if (parent.frames.length > 0) {
   parent.location = self.document.location
}

function ShowWaitIndicator() {
   //disable logon button
   var logonButton = <HTMLButtonElement>document.getElementById('cButtonLogon');
   logonButton.disabled = true;

   //wok - 7.8.26 - Web: also disable the optional "Starter" button (launches Tex-Define CS Starter directly)
   var starterButton = <HTMLButtonElement>document.getElementById('cButtonStarter');
   if (starterButton != null) {
      starterButton.disabled = true;
   }

   //OG - 13.9.13 disable a-Tag         
   var cp = <HTMLButtonElement>document.getElementById('changePassword');
   if (cp != null) {
      cp.disabled = true;
   }

   var progressIndicator = document.getElementById('cProgressIndicator');
   progressIndicator.style.visibility = 'visible';

   var message = document.getElementById('cMessage');
   message.innerHTML = 'Init session...';
   message.style.color = "#000000";

   return true;
}

function changePassword() {
   var oldPassword = $('#oldPassword');
   var password = $('#password');
   var passwordCofirm = $('#passwordCofirm');
   var pUserName = $('#pUserName');
   // wok - 20.11.17 - added ClientJS for client fingerprinting
   var cFieldFingerprint = $('#cFieldFingerprint');
   var cFieldPINorTAN = $('#cFieldPINorTAN');

   var e1 = $('#error1');
   var e2 = $('#error2');
   var e3 = $('#error3');
   var e4 = $('#error4');

   e1.removeClass('label');
   e1.addClass('labelD');
   e2.removeClass('label');
   e2.addClass('labelD');
   e3.removeClass('label');
   e3.addClass('labelD');
   e4.removeClass('label');
   e4.addClass('labelD');

   oldPassword.val('');
   password.val('');
   passwordCofirm.val('');
   pUserName.val('');

   oldPassword.removeClass('inputE');
   password.removeClass('inputE');
   passwordCofirm.removeClass('inputE');
   pUserName.removeClass('inputE');
   //call the dialog
   $("#changePasswordDialog").dialog({
      resizable: false,
      height: 470,
      width: 300,
      display: 'inline',
      modal: true,
      buttons:
      [
         {
            text: "Ok",
            click: function () {
               if (!validate()) return;
               var currentLoadingPanel = <any>$find(LogonAspxRadAjaxLoadingPanel1ClientID);
               currentLoadingPanel.show('changePasswordDialogParent');
               var currentDialog = $(this);

               try {
                  // wok - 20.11.17 - added ClientJS for client fingerprinting
                  //var strFieldPINorTAN = cFieldPINorTAN.val;
                  //var strFingerprint = cFieldFingerprint.val;
                  var service = (<any>Sys.Net).WebServiceProxy.invoke("services/PreLoginWS.asmx", "ChangePassword", false, { "pUserName": pUserName.val(), "pOldPassword": oldPassword.val(), "pNewPassword": password.val(), "pPinOrTan": cFieldPINorTAN.val(), "pFingerprint": cFieldFingerprint.val() },
                     function (data, w) {
                        currentLoadingPanel.hide('changePasswordDialogParent');
                        var message = data.ErrorMessage;
                        if (message == "")
                           message = $('#ErrorMessage').text();
                        if (data != null) {
                           var pwdChanged = data.Result;

                           if (!pwdChanged) {
                              e3.text(message);
                              e3.removeClass('labelD');
                              e3.addClass('label');
                           }
                           else {
                              alert(message);
                              currentDialog.dialog("close");
                           }
                        }
                     },
                     function (e, w) {
                        currentLoadingPanel.hide('changePasswordDialogParent');
                        e3.text(e.get_message());
                        e3.removeClass('labelD');
                        e3.addClass('label');
                     },
                     null,
                     30000);

               } catch (ex) {
                  currentLoadingPanel.hide('changePasswordDialogParent');
                  e3.text(ex.message);
                  e3.removeClass('labelD');
                  e3.addClass('label');
               }
            }
         },
         {
            text: $('#ltCancel').text(),
            click: function () {
               $(this).dialog("close");
            }
         }
      ]
   });

   if ($('#changePasswordDialogParent').attr("class") == null || $('#changePasswordDialogParent').attr("class").indexOf('ui-widget') < 0) {
      $('.ui-dialog-titlebar-close').remove();
      $('#changePasswordDialogParent').remove();
      $('#changePasswordDialog').parent().attr('id', 'changePasswordDialogParent');
   }
}
function validate() {
   var e1 = $('#error1');
   var e2 = $('#error2');
   var e3 = $('#error3');
   var e4 = $('#error4');

   var oldPassword = $('#oldPassword');
   var password = $('#password');
   var passwordCofirm = $('#passwordCofirm');
   var pUserName = $('#pUserName');

   if (!emptyValidate(pUserName, e4)) return false;
   if (!containsChar(pUserName, e4, "\\") && !containsChar(pUserName, e4, "@")) {
      e4.text($('#domainError').text());
      return false;
   }
   if (!emptyValidate(oldPassword, e1)) return false;
   if (!emptyValidate(password, e2)) return false;
   if (!emptyValidate(passwordCofirm, e3)) return false;

   if (password.val() != passwordCofirm.val()) {
      passwordCofirm.addClass('inputE');
      e3.text($('#PasswordConfirmError').text());
      e3.removeClass('labelD');
      e3.addClass('label');
      return false;
   }
   else {
      passwordCofirm.removeClass('inputE');
      e3.removeClass('label');
      e3.addClass('labelD');
      return true;
   }
}

function containsChar(input, error, char) {
   if (input.val().indexOf(char) > 0) {
      input.removeClass('inputE');
      error.removeClass('label');
      error.addClass('labelD');
      return true;
   }
   else {
      input.addClass('inputE');
      error.removeClass('labelD');
      error.addClass('label');
      return false;
   }
}
function emptyValidate(input, error) {
   if (input.val() === "") {
      input.addClass('inputE');
      error.removeClass('labelD');
      error.addClass('label');
      //error.text('Leere Eingaben sind nicht erlaubt');
      return false;
   }
   else {
      input.removeClass('inputE');
      error.removeClass('label');
      error.addClass('labelD');
      return true;
   }
}
//OG - 8.10.13 - workaround for the known bug in .net 3.5
//Function.emptyFunction = Function.emptyMethod = function Function$emptyMethod() {}

$(document).ready(function () {
   console.log('is ready')
   // wok - 20.11.17 - added ClientJS for client fingerprinting
   return readyFunctionLogonAspx();
});
